import React from 'react';
import { Spin } from 'antd';

/**
 * LazySpinner Component
 * 
 * Displays a loading spinner for asynchronous operations.
 * Can be connected to global loading states.
 */
const LazySpinner: React.FC = () => {
  // In a real implementation, this would be connected to a loading state
  const isLoading = false;

  if (!isLoading) {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(255, 255, 255, 0.7)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999
    }}>
      <Spin size="large" tip="Loading..." />
    </div>
  );
};

export default LazySpinner;
